import type { CSSProperties } from "react";

export const warningAccentColor = "#D97706";
export const warningSurfaceBackground = "rgba(217, 119, 6, 0.08)";
export const warningSurfaceBorder = "1px solid rgba(217, 119, 6, 0.2)";
export const warningSurfaceBorderColor = "rgba(217, 119, 6, 0.2)";

export const warningSurfaceStyle: CSSProperties = {
  backgroundColor: warningSurfaceBackground,
  border: warningSurfaceBorder
};

export const warningSurfaceTextStyle: CSSProperties = {
  ...warningSurfaceStyle,
  color: warningAccentColor
};

export const warningTextStyle: CSSProperties = {
  color: warningAccentColor
};

export const warningAccentBackgroundStyle: CSSProperties = {
  backgroundColor: warningAccentColor
};

export const warningAccentBorderStyle: CSSProperties = {
  borderColor: warningAccentColor
};

export const warningSoftBorderStyle: CSSProperties = {
  borderColor: warningSurfaceBorderColor
};

export function WarningAlertIcon() {
  return (
    <svg width="11" height="11" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
      <path d="M8 1.5l6.5 11.5h-13L8 1.5z" stroke="#D97706" strokeWidth="1.4" strokeLinejoin="round" />
      <path d="M8 6v3M8 11h.01" stroke="#D97706" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}
